import {createSelector} from 'reselect';

import {featureFlagsSelector} from '../../../../store/gsConfig/selectors';
import FEATURE_FLAGS from '../../../../utils/featureFlags';

const listingSelector = ({buildyourorder = {}}) => buildyourorder.listing;

export const faceValueSelector = createSelector(listingSelector, (listing = {}) => {
  const {products} = listing;
  if (!products) {
    return null;
  }
  const faceValues = [];
  products.forEach(({faceValue: currentProductFaceValue}) => {
    if (currentProductFaceValue) {
      const item = faceValues.find((currentFaceValue) => currentProductFaceValue.amount === currentFaceValue.amount);
      if (item) {
        item.quantity++;
      } else {
        faceValues.push({...currentProductFaceValue, quantity: 1});
      }
    }
  });
  faceValues.sort(({amount: firstAmount}, {amount: secondAmount}) => secondAmount - firstAmount);

  return faceValues;
});

export const deviceSelector = (state) => state?.device || null;

export const showTrustMessagesSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.common.trustMessages]
);

export const showLegalSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.event.legal.showLegalMessages]
);

export const showPriceVaryFaceValueSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.byo.legal.priceVaryFaceValue.show]
);

export const showPriceSetBySellerSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.byo.legal.priceSetBySeller.show]
);

export const preSelectIncludeFeesSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.event.legal.priceIncludeFees]
);

export const hideEstimatedFeeSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.event.legal.hideEstimatedFee]
);

export const showPriceIncludeVATSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.event.legal.priceIncludeVAT]
);

export const showNonOfficialSelector = createSelector(
  featureFlagsSelector,
  (features) => features && features[FEATURE_FLAGS.byo.legal.nonOfficial.show]
);

export const showFaceValueSelector = createSelector(
  ({event = {}}) => event.showFaceValue,
  (faceValue = {}) => faceValue.value
);
